<template>
  <div class="w-full flex flex-col items-center justify-center text-center text-white p-3 lg:p-6"
    style="background-color: #016B00;">
    <div class="text-lg md:text-xl lg:text-3xl font-semibold tracking-wide">
      {{ countdown.days }} <span class="font-light">Days</span>
      {{ countdown.hours }} <span class="font-light">Hrs</span>
      {{ countdown.minutes }} <span class="font-light">Mins</span>
      {{ countdown.seconds }} <span class="font-light">Secs</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CounterSection",
  data() {
    return {
      countdown: {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      },
      timer: null,
    };
  },
  computed: {
    sched() {
      return this.$store.state.sched || {};
    },
    targetDate() {
      if (this.sched && this.sched.event_date) {
        return new Date(`${this.sched.event_date}T23:59:59`);
      }
      return null;
    },
  },
  watch: {
    // 👇 Watch for when sched becomes available from Vuex
    sched: {
      handler(newVal) {
        if (newVal && newVal.event_date) {
          console.log("🎯 Schedule detected in CounterSection:", newVal);
          this.startCountdown();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    startCountdown() {
      clearInterval(this.timer);
      this.updateCountdown();
      this.timer = setInterval(this.updateCountdown, 1000);
    },
    updateCountdown() {
      if (!this.targetDate) return;

      const now = new Date().getTime();
      const distance = this.targetDate.getTime() - now;

      if (distance <= 0) {
        clearInterval(this.timer);
        this.countdown = { days: "00", hours: "00", minutes: "00", seconds: "00" };
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.countdown = {
        days: days.toString().padStart(2, "0"),
        hours: hours.toString().padStart(2, "0"),
        minutes: minutes.toString().padStart(2, "0"),
        seconds: seconds.toString().padStart(2, "0"),
      };
    },
  },
};
</script>

<style scoped></style>
